import { fromJS } from 'immutable'
import * as viewer from './ViewerActions'

const initialState = fromJS({
	isOpen: false,
	isLoading: false,
	error: null,
	asset: null,
	blobUrl: null,
	requestId: 0
})

const viewerReducer = (state = initialState, action) => {
	switch (action.type) {
		case viewer.OPEN_VIEWER: {
			return state
				.set('isOpen', true)
				.set('isLoading', true)
				.set('error', null)
				.set('blobUrl', null)
				.set('asset', fromJS(action.asset))
				.set('requestId', action.requestId)
		}
		case viewer.SET_VIEWER_BLOB_URL: {
			// Discard stale responses (user clicked another asset before this
			// fetch resolved). Only apply if the request id matches the active
			// one in state.
			if (action.requestId !== state.get('requestId')) return state
			return state
				.set('isLoading', false)
				.set('error', null)
				.set('blobUrl', action.blobUrl)
		}
		case viewer.SET_VIEWER_ERROR: {
			if (action.requestId !== state.get('requestId')) return state
			return state.set('isLoading', false).set('error', action.message || 'Request failed')
		}
		case viewer.CLOSE_VIEWER: {
			return initialState
		}
		default:
			return state
	}
}

export default viewerReducer
